/**
 * We use this file to contain basic environment settings for the application.
 */
export const environment = {
    // The location of the API host.
    api_host: 'https://api.macnoms.com',
    application_name: 'legacy_complaints',
    flighttracker: 'http://macnoms.com'
}